import type { GetRequestsListItem } from "@nlc/shared-types";

import { whitelabelRowClassName } from "@/features/requests/constants/accountTags";

import type { TableConfig } from "../../../types/tables";

import { TABLE_LAYOUT_PRESETS } from "../../constants/columnWidths";
import { accountTagsCell } from "../../helpers/accountTagsCell";
import {
  accountCell,
  createdByCell,
  dateCell,
  designTypeCell,
  nameCell,
} from "../../helpers/commonCells";
import { renderRating } from "../../helpers/renderHelpers";

// Completed Tab Configuration for Designer "Assigned to Me"
// Columns: Name, Account, Created by, Completed date, Rating, Request/Design type
export const designerCompletedTableConfig: TableConfig<GetRequestsListItem> = {
  columns: [
    {
      accessor: "name",
      cellRenderer: nameCell,
      header: "Name",
      key: "name",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.name,
    },
    {
      accessor: "account",
      cellRenderer: accountCell,
      header: "Account",
      key: "account",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.account,
    },
    {
      accessor: "createdBy",
      cellRenderer: createdByCell,
      header: "Created by",
      key: "createdBy",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.createdBy,
    },
    {
      accessor: "completedDate",
      cellRenderer: dateCell,
      header: "Completed date",
      key: "completedDate",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.completedDate,
    },
    {
      accessor: "rating",
      cellRenderer: (value: unknown) =>
        renderRating(value as null | number | undefined),
      header: "Rating",
      key: "rating",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.rating,
    },
    {
      accessor: "designType",
      cellRenderer: designTypeCell,
      header: "Design Type",
      key: "designType",
      sortable: true,
      width: TABLE_LAYOUT_PRESETS.superadmin.requestType,
    },
    {
      accessor: "account",
      cellRenderer: accountTagsCell,
      header: "Tags",
      key: "accountTags",
      sortable: false,
      width: 150,
    },
  ],
  defaultSort: {
    column: "completedDate",
    direction: "desc",
  },
  enableSorting: true,
  getRowClassName: whitelabelRowClassName,
  id: "designer-completed-requests",
  title: "Completed Requests",
};
